<template>
  <div>
    <div class="paragraph-text">
      <div ref="Title" class="title">{{ module.titolo }}</div>
      <div class="paragraph-text-bottom">
        <div ref="Description">
          <div v-if="module.body_text.value" class="description" v-html="module.body_text.value"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'basic_text',
    props: ['module'],
    data() {
      return {
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {},
    components: {}
  }
</script>
